export const ADVISER = "adviser";
export const STUDENT = "student";
export const TEACHER = "teacher";
export const SUPER_ADMIN = "super-admin";
export const SCHOOL_ADMIN = "school-admin"; // school-admin is now 'teacher' role
